import { useSwipeable } from 'react-swipeable';
import { FCP } from 'types';

interface Props extends FCP {
  onSwipedLeft?(): void;
  onSwipedRight?(): void;
}

export const Swipe = ({
  onSwipedLeft = () => null,
  onSwipedRight = () => null,
  children,
  className = '',
}: Props) => {
  const handlers = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
  });

  return (
    <div className={className} {...handlers}>
      {children}
    </div>
  );
};
